import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import { Paginated } from '../../../../adl-gen/common';
import { DbKey } from '../../../../adl-gen/common/db';
import { AppClient } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { AppClientListEntry } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { Loader, MaybeLoading } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { ListView } from '../../common/list/list-view';
import { AdminPageLayoutFn } from '../../common/page-layout/admin-page-layout';
import { AppClientListView } from '../../components/lists/appclient-list/appclient-list-view';

interface AppClientScreenProps {
  pageLayout: AdminPageLayoutFn;
  navigateTo(route: Route): void;

  clients: MaybeLoading<Paginated<AppClientListEntry>>;
}

@observer
export class AppClientScreen extends React.Component<AppClientScreenProps> {
  @observable.ref isOpen = false;

  @action toggleOpen(): void {
    this.isOpen = !this.isOpen;
  }

  @action
  onCancel = () => {
    this.toggleOpen();
  };

  onSelectClient = async (appClientId: DbKey<AppClient>) => {
    this.props.navigateTo({
      route: 'admin',
      page: 'client',
      appClientId,
      id: appClientId
    });
  };

  onCreateClient = () => {
    this.props.navigateTo({
      route: 'admin',
      page: 'client',
      view: 'new'
    });
  };

  renderClientList = observer((clients: Paginated<AppClientListEntry>) => {
    return (
      <ListView
        list={clients}
        fields={AppClientListView}
        onSelect={this.onSelectClient}
        onCreate={this.onCreateClient}
      />
    );
  });

  ClientsLoader = () => <Loader state={this.props.clients} LoadedComponent={this.renderClientList} />;

  render() {
    /// Title is required to ensure subnav gets rendered
    return (
      <this.props.pageLayout title={'Administration'}>
        <this.ClientsLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/appclient-screen/appclient-screen.tsx